/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_No_ViewsInputs */



/**
* | output |
* | --- |
* | "No metadata views available for this asset." |
*
* @param {Iconik_Metadata_No_ViewsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_no_views = /** @type {((inputs?: Iconik_Metadata_No_ViewsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_No_ViewsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("No metadata views available for this asset.")
	if (locale === "de") return /** @type {LocalizedString} */ ("No metadata views available for this asset.")
	if (locale === "it") return /** @type {LocalizedString} */ ("No metadata views available for this asset.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("No metadata views available for this asset.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No metadata views available for this asset.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("No metadata views available for this asset.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("No metadata views available for this asset.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("No metadata views available for this asset.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("No metadata views available for this asset.")
	return /** @type {LocalizedString} */ ("No metadata views available for this asset.")
});